"use client"
/* */
function isPropsWithChildren(props) {
  return !!props && typeof props === "object" && "children" in props && !!props.children;
}

export { isPropsWithChildren };
//# sourceMappingURL=isPropsWithChildren.mjs.map
